module.exports = __webpack_public_path__ + "static/media/가지급금 관리.68fab2e9.png";